import React, { useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import { btnStyle, LandingTitle } from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { Loading } from "..";
import Auth from "../../lib/middleware/auth";
import { InputContainer } from "../Donate/component";
import CurrencyFormat from "react-currency-format";
import { useInitializePayment } from "../../redux/api/Transaction";

const Wrapper = styled.div`
	${tw`p-2 h-full bg-white w-full flex flex-col container`}
	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;
	@media (max-width: 1217px) {
		height: auto;
	}
`;

const FundWallet = (props) => {
	// const curr = Auth.getCurrency();
	const user = Auth.getUser();

	const [fields, setFields] = useState({
		amount: "",
		pin: "",
	});
	// const currencyCode = curr?.code;

	const { mutateAsync: handlePay, isLoading: loadPayment } =
		useInitializePayment();
	// console.log("Withdrawble \n", withdrawable);

	const handleFundWallet = async () => {
		if (isEmpty(fields.amount)) {
			Toast.fire({
				icon: "error",
				title: `Please enter a valid amount`,
			});
			return;
		}
		const data = {
			purpose: "fund",
			amount: fields.amount,
			payment_gateway: "paystack",
			email: user.email,
			currencyCode: "NGN", //user.currency.code,
		};

		try {
			const response = await handlePay(data);
			console.log("Fund wallet res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				Toast.fire({
					icon: "error",
					title: `${response.data.errors.title}\n ${response.data.errors.message} `,
				});
				return;
			}
			const { authorization_url } = response.data.data.data;
			Toast.fire({
				icon: "success",
				title: `You will be redirected to payment page`,
			});
			setTimeout(() => {
				window.location.href = `${authorization_url}`;
			}, 500);
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	return (
		<Wrapper>
			<div
				tw="mb-4 h-8 w-8 px-2 py-2 bg-gray-100 rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex flex-col items-center justify-center"
				onClick={() => props.goBack()}>
				<ArrowLeftOutlined tw="hover:(text-purple-800 transform scale-125)" />
			</div>
			<LandingTitle tw="text-center text-lg! mb-4">
				How much do you want to deposit?
			</LandingTitle>

			<InputContainer>
				<CurrencyFormat
					value={fields.amount}
					allowNegative={false}
					displayType={"input"}
					thousandSeparator={true}
					placeholder={"00.00"}
					type="tel"
					decimalScale={2}
					fixedDecimalScale={true}
					onValueChange={(values) => {
						const { value } = values;
						setFields({ ...fields, amount: value });
					}}
					prefix={"₦"}
				/>
			</InputContainer>

			<div tw="flex flex-row flex-nowrap gap-2 items-center"></div>

			<div tw="mt-4 mb-8">
				<button
					css={btnStyle}
					tw="rounded-lg"
					onClick={handleFundWallet}>
					{loadPayment ? <Loading /> : "Continue"}
				</button>
			</div>
		</Wrapper>
	);
};

export default FundWallet;
